import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsReactivexComponent } from './simple-icons-reactivex.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsReactivexComponent ],
    exports:      [ SimpleIconsReactivexComponent ],
    bootstrap:    []
})
export class SimpleIconsReactivexModule {}
